import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CommonSettings } from 'epay-library';
import { EmployerService } from '../../services/employer.service';

@Component({
  selector: 'epay-employer-register',
  templateUrl: './employer.register.component.html',
})
export class EMPRegisterComponent implements OnInit, AfterViewInit {
  pagetitle = 'Employer: Create Account';
  baseurl = '';
  termsContent = '';
  loginHelp = '';
  canCreateNewEmployer: boolean;
  useEmailForLogin = CommonSettings.UseEmailForLogin;
  allowEINSearch = CommonSettings.AllowEINSearch;

  constructor(private employerService: EmployerService) {
    this.baseurl = CommonSettings.BaseApi;
    this.canCreateNewEmployer = CommonSettings.CanCreateNewEmployer;
  }

  ngOnInit() {
    this.employerService.getEmployerTerms().subscribe((result: any) => {
      this.termsContent = result;
    });
    this.employerService.getLoginHelp().subscribe((result: any) => {
      this.loginHelp = result;
    });
  }

  ngAfterViewInit(): void {
    this.horizontalStepperRoleFix()
  }

  horizontalStepperRoleFix() {
   document.getElementsByClassName('mat-horizontal-stepper-header-container')[0].setAttribute('role', 'tablist');
   document.getElementsByClassName('mat-stepper-horizontal')[0].removeAttribute('role');
  }
}
